<template>
  <md-card class="table-card md-layout">
    <md-card-header class="md-card-header-icon md-card-header-green md-layout md-alignment-center">
      <h4 v-if="title" class="md-layout-item md-size-75">
        <strong>{{title}}</strong>
      </h4>
      <div class="md-size-25 ml-auto">
        <slot name="header"></slot>
      </div>
    </md-card-header>

    <md-card-content>
      <slot name="content"></slot>
    </md-card-content>

    <!-- <md-card-actions md-alignment="space-between"> -->
    <slot name="footer"></slot>
    <!-- </md-card-actions> -->
  </md-card>
</template>


<script>
export default {
  props: {
    title: String,
    icon: {
      type: String,
      default: "assignment",
    },
  },

  data() {
    return {};
  },
};
</script>

<style lang="css" scoped>
.md-card.table-card {
  z-index: 0;
}

.md-card-content > .md-content {
  max-height: 1000px;
}

.mt-auto {
  margin-top: -10px !important;
  margin-right: 5px !important;
  margin-left: 5px !important;
}

.action-tooltip {
  font-size: 16px !important;
}
h4 {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Tables/TableCardLayout.vue